/** @file Sockets panel body: sockets by name (parent bone noted), a new-socket row, points and held items. */
import { entriesByName } from '@pose2d/format/doc/entriesByName';
import { useState } from 'react';
import { listHandlers } from '../rigKit/listHandlers';
import { NamedList } from '../rigKit/NamedList';
import type { RigView } from '../rigKit/rigView';
import { SocketCreate } from './SocketCreate';
import { SocketItems } from './SocketItems';
import { SocketPoints } from './SocketPoints';

/** Rename appears once X2 registers socket.rename (listHandlers); delete re-homes the slots (socket.delete). */
export function SocketsView({ doc, t, run }: RigView) {
  const [picked, setPicked] = useState<string | null>(null);
  const rows = entriesByName(doc.sockets).map(([id, s]) => ({ id, name: s.name, note: doc.bones[s.parentBone]?.name ?? s.parentBone }));
  const socket = picked === null ? undefined : doc.sockets[picked];
  return (
    <div className="rig-body">
      <NamedList t={t} label={t('panels.sockets.title')} rows={rows} selected={socket === undefined ? null : picked} onSelect={setPicked} {...listHandlers('socket', run)} />
      <SocketCreate doc={doc} t={t} run={run} />
      {picked !== null && socket !== undefined && (
        <>
          <SocketPoints t={t} run={run} id={picked} socket={socket} />
          <SocketItems doc={doc} t={t} run={run} socket={picked} />
        </>
      )}
    </div>
  );
}
